import React from 'react';
import i18n from '@/app/i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log('Tried to parse: ', this.props.content);
  }

  render() {
    if (this.state.hasError) {
      return <span>{i18n.t('Failed to parse text')}</span>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
